import { Divider } from "@mui/material"
import { CarModelFinishingLevelDto, CarModelFinishingLevelEngineDto } from "api"
import { FormikProvider } from "formik"
import FormSelect from "reusable/formsComp/FormSelect"
import styled from "styled-components"

const StyledModelContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const StyledModelHeader = styled.h2`
  font-family: "MazdaType";
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;

  text-align: center;
  letter-spacing: 0.06em;

  color: ${(p) => p.theme.colors.black};
  margin: 10px 0;
  ${(p) => p.theme.breakpoints.up("md")} {
    font-weight: 500;
    font-size: 32px;
    line-height: 44.8px;
    letter-spacing: 1.11;
  }
`
const StyledModelBox = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 10px 20px;
  gap: 30px;

  background: ${(p) => p.theme.colors.lightGrey};
  border-radius: 3px;
  margin-bottom: 30px;
`

const StyledSelectGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 16px;
  ${(p) => p.theme.breakpoints.up("md")} {
    grid-gap: 30px;
  }
  .comfbo .MuiSelect-select {
    flex-direction: row;
  }
`

const StyledModelImage = styled.img`
  width: 280px;
  height: 129px;
  object-fit: cover;
  align-self: center;
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 293px;
    object-fit: cover;
  }
`

const StyledModelDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${(p) => p.theme.breakpoints.up("md")} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 67px;
  }
`

const StyledModelDetail = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 42px;
`

const DetailText = styled.p`
  font-family: "MazdaType";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;

  text-align: center;

  color: ${(p) => p.theme.colors.black};
  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 16px;
    font-weight: 400;
    line-height: 22.4px;
  }
`

const DetailTextHeader = styled.p`
  font-family: OENaPro;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  color: ${(p) => p.theme.colors.black};

  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 12px;
    font-weight: 300;
    line-height: 15.6px;
  }
`

const StyledModelDetailPadding = styled.div`
  padding: 0px 10px;
`
type Props = {
  modelName: string
  formik: any
  engines: CarModelFinishingLevelEngineDto[]
  finishingLevels: CarModelFinishingLevelDto[]
  selected: any
}

function TopModelDetails({
  modelName,
  formik,
  engines,
  finishingLevels,
  selected,
}: Props) {
  return (
    <StyledModelContainer>
      <StyledModelHeader>{modelName}</StyledModelHeader>
      <StyledModelBox>
        <FormikProvider value={formik}>
          <StyledSelectGrid>
            <FormSelect
              name="engineId"
              label="בחירת מנוע"
              values={engines}
              map={(item) => ({
                id: item?.engineId,
                name: item?.engineName,
              })}
              title="engineId"
            />
            <FormSelect
              name="finishingLevel"
              label="בחירת רמת גימור"
              values={finishingLevels}
              map={(item) => ({ id: item?.name, name: item?.name })}
              title="finishingLevel"
            />
          </StyledSelectGrid>
        </FormikProvider>
        <StyledModelDataContainer tabIndex={0}>
          <StyledModelImage
            src={selected?.image?.imageUrl}
            alt={selected?.image?.alt || "car model details"}
          />
          <StyledModelDetailPadding>
            <StyledModelDetail>
              <DetailTextHeader>מחיר (כולל מע״מ)</DetailTextHeader>
              <DetailText>₪{selected?.price?.toLocaleString()}</DetailText>
            </StyledModelDetail>
            <Divider
              style={{
                width: "100%",
                backgroundColor: "#E7E7E7",
                height: "1px",
              }}
            />
            <StyledModelDetail>
              <DetailTextHeader>אגרת רישוי</DetailTextHeader>
              <DetailText>₪{selected?.licenceFee?.toLocaleString()}</DetailText>
            </StyledModelDetail>
            <Divider
              style={{
                width: "100%",
                backgroundColor: "#E7E7E7",
                height: "1px",
              }}
            />

            <StyledModelDetail>
              <DetailTextHeader>סה״כ מחיר רכב</DetailTextHeader>
              <DetailText style={{ fontSize: "24px" }}>
                ₪{(selected?.price + selected?.licenceFee)?.toLocaleString()}
              </DetailText>
            </StyledModelDetail>
          </StyledModelDetailPadding>
        </StyledModelDataContainer>
      </StyledModelBox>
    </StyledModelContainer>
  )
}

export default TopModelDetails
